import styled from '@emotion/styled'

import { Failed } from '@arcade/web/icons/react'

import { Copy } from './DatePickerCopy'

const Bar = styled.div`
  ${props => props.theme.typography.mainTitle};
  color: ${props => props.theme.colors.label};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  height: 1.5rem;
  cursor: pointer;
`

export const DatePickerTitleBar = ({ copy, onClose }: { copy: Copy; onClose?: () => void }) => {
  return (
    <Bar>
      <span>{copy.titleBar.text}</span>
      <CloseButton type="button" aria-label={copy.titleBar.closeLabel} onClick={() => onClose?.()}>
        <Failed size={24} />
      </CloseButton>
    </Bar>
  )
}
